import React from 'react';
import LazyloadImage from './LazyloadImage';
import {LeadImage} from './leadImage';

export default class AlbumListingImageWithFavorite extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      containerClassName,
      smartCrop,
      desktopWidth,
      desktopHeight,
      mobileWidth,
      mobileHeight,
      is_mobile,
      isLeadImage,
      favoriteParams,
      favoriteTrackingData,
      id,
    } = this.props;

    let mediaEnv = process.env.RAILS_ENV == 'production' ? '' : 'qa-';
    let desktop_width = desktopWidth || 311;
    let desktop_height = desktopHeight || 229;
    let mobile_width = mobileWidth || 302;
    let mobile_height = mobileHeight || 227;

    // Determine which component to render based on conditions
    if (isLeadImage && is_mobile) {
      return (
        <LeadImage
          containerClassName={containerClassName || 'album-main-thumb'}
          width={is_mobile ? mobile_width : desktop_width}
          height={is_mobile ? mobile_height : desktop_height}
          desktopWidth={desktop_width}
          desktopHeight={desktop_height}
          mobileWidth={mobile_width}
          mobileHeight={mobile_height}
          mediaEnv={mediaEnv}
          favorite_params={favoriteParams}
          favoriteTrackingData={favoriteTrackingData}
          id={id}
          {...this.props}
        />
      );
    } else {
      return (
        <LazyloadImage
          containerClassName={containerClassName || 'album-main-thumb'}
          smartCrop={smartCrop || true}
          desktopWidth={desktop_width}
          desktopHeight={desktop_height}
          mobileWidth={mobile_width}
          mobileHeight={mobile_height}
          width={is_mobile ? mobile_width : desktop_width}
          height={is_mobile ? mobile_height : desktop_height}
          lazy={!isLeadImage}
          favorite_params={favoriteParams}
          favoriteTrackingData={favoriteTrackingData}
          id={id}
          {...this.props}
        />
      );
    }
  }
}
